export default __webpack_public_path__ + "static/media/cx.581114d7.svg";